import React, {useState} from 'react';
import useUserContext from "../../hooks/useUserContext";
import UnifiedTable from "../Indexes/UnifiedTable";
import {createFirstCols} from "../../helpers/unified";
import {useParams} from "react-router-dom";
import useNavProject from "../../hooks/useNavProject";

const UnifiedSPTable = () => {
    const userCtx = useUserContext()
    const {stratId,policyId,projId,portfolioId} = useParams()
    const [originalData, setOriginalData] = useState([]);
    const navProject = useNavProject()

    const firstCols = createFirstCols(originalData,navProject,'strat',{stratId,policyId,projId,portfolioId})
        .addStartColumn({title:'№', field:'num', filtering:true, width:80, sticky: true, filterCellStyle: { minWidth: '60px' },})
    return (
        <UnifiedTable
            firstCols={firstCols}
            canExport={true}
            data={{originalData,setOriginalData}}
            hasChildData={false}/>
    );
};

export default UnifiedSPTable;
